var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('transition',{attrs:{"name":"slide-left"}},[_c('div',[_c(_vm.useTemplate,{tag:"component",attrs:{"stepColor":_vm.wizardStepColor,"errorColor":_vm.wizardErrorColor}})],1)])}
var staticRenderFns = []

export { render, staticRenderFns }